// extracted by mini-css-extract-plugin
module.exports = {"main-component":"lineChart_main-component__23N_D"};